export default {"src":"/_next/static/media/powered-by-formbricks.8d044b79.svg","height":200,"width":641,"blurWidth":0,"blurHeight":0};